









































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { State, Action } from "vuex-class";
import moment from "moment";

@Component
export default class FileManagementDialog extends Vue {
  @Prop({ type: Boolean, default: false }) value!: boolean;
  @Prop({ type: Object, default: null }) product!: any;

  @State("productFiles") productFilesState: any;
  @Action("getProductFiles") getProductFiles: any;
  @Action("uploadProductFile") uploadProductFile: any;
  @Action("deleteProductFile") deleteProductFile: any;
  @Action("updateFileDescription") updateFileDescription: any;
  @Action("downloadProductFile") downloadProductFile: any;

  selectedFiles: File[] = [];
  editingFileId = null;
  editingDescription = "";

  get dialog() {
    return this.value;
  }

  set dialog(value) {
    this.$emit("input", value);
  }

  @Watch("dialog")
  onDialogChange(newVal: boolean) {
    if (newVal && this.product) {
      this.loadFiles();
    }
  }

  async loadFiles() {
    if (this.product && this.product.productId) {
      await this.getProductFiles(this.product.productId);
    }
  }

  handleFileSelection(event) {
    const files = Array.from(event.target.files || []) as File[];
    this.selectedFiles = files;
    // Clear the file input value so the same file can be selected again
    event.target.value = "";
  }

  removeFile(index) {
    this.selectedFiles.splice(index, 1);
  }

  closeDialog() {
    this.dialog = false;
    this.selectedFiles = [];
    this.editingFileId = null;
    this.editingDescription = "";
  }



  async uploadFiles() {
    if (!this.selectedFiles || this.selectedFiles.length === 0 || !this.product) {
      return;
    }

    for (const file of this.selectedFiles) {
      try {
        await this.uploadProductFile({ productId: this.product.productId, file });
      } catch (error) {
        console.error("Error uploading file:", error);
      }
    }

    this.selectedFiles = [];
    // Refresh the file list
    await this.getProductFiles(this.product.productId);
  }

  async deleteFile(productFileId) {
    if (confirm(this.$t("FILE_DELETE_CONFIRM") as string)) {
      try {
        await this.deleteProductFile(productFileId);
      } catch (error) {
        console.error("Error deleting file:", error);
      }
    }
  }

  async downloadFile(productFile) {
    try {
      const response = await this.downloadProductFile(productFile.productFileId);
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", productFile.originalFileName); // The actual filename will be set by the server
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  }

  editFileDescription(file) {
    this.editingFileId = file.productFileId;
    this.editingDescription = file.description || "";
  }

  async saveFileDescription(productFileId) {
    try {
      await this.updateFileDescription({ productFileId, description: this.editingDescription });
      this.editingFileId = null;
      this.editingDescription = "";
    } catch (error) {
      console.error("Error updating file description:", error);
    }
  }

  cancelEditDescription() {
    this.editingFileId = null;
    this.editingDescription = "";
  }

  getFileHeaders() {
    return [
      { text: this.$t("FILE_NAME"), value: "originalFileName", width: "20%", align: "left" },
      { text: this.$t("FILE_SIZE"), value: "fileSize", width: "10%", align: "left" },
      { text: this.$t("FILE_TYPE"), value: "fileExtension", width: "10%", align: "left" },
      { text: this.$t("UPLOADED_BY"), value: "user.userName", width: "15%", align: "left" },
      { text: this.$t("UPLOAD_DATE"), value: "createdDate", width: "15%", align: "left" },
      { text: this.$t("DESCRIPTION"), value: "description", width: "20%", align: "left" },
      { text: this.$t("TABLE_ACTIONS"), value: "actions", width: "10%", align: "left", sortable: false }
    ];
  }

  formatFileSize(bytes) {
    if (bytes === 0) {
      return "0 Bytes";
    }
    const k = 1024;
    const sizes = ["Bytes", "KB", "MB", "GB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
  }

  formatDateTime(d) {
    if (d != null) {
      return moment(d).format("YYYY-MM-DD HH:mm:ss");
    } else {
      return "";
    }
  }
}
